<template>
    <div class="onboarding-container onboarding-datetimepicker row visible-on col-md-8 col-lg-5 col-md-offset-1 col-lg-offset-3">
        <span ref="form-label" :class="['col-xs-12 col-sm-5 col-md-5 col-lg-4 form-label', fixStyle]">{{ label }}</span>
        <div v-clickoutside="closePickerItems" :class="['datetimepicker-container col-xs-12 col-sm-5 col-md-7 col-lg-8', isDisabled ? 'disable-bkg' : '', internalErrorMessage ? 'error-border' : 'normal-border']">
          <div :class="['datetimepicker-selected form-component']" @click="toggle">
            <input ref="input" data-sp-input autocomplete="off" :value="inputValue" :placeholder="placeholder" @keypress.enter="onPressEnter"/>
            <img class="date-img" :src="dateUrl" alt="">
          </div>
          <div class="datetimepicker-items" v-show="showItem">
              <!-- 最上部年月显示以及翻页 -->
              <div class="year-month-display">
                  <img class='change-time-img' :src="yearleftUrl" alt="" @click="changeYear('-')">
                  <div class="internal-div">
                    <img class='change-time-img' v-show="isShowDaySelector" :src="monthleftUrl" alt="" @click="changeMonth('-')">
                    <div class="center-display">
                      <span class="year" @click="openYearSelector">{{ currentYearText }}</span>
                      <span class="month" v-show="isShowDaySelector" @click="openMonthSelector">{{ currentMonthText }}</span>
                    </div>
                    <img class='change-time-img' v-show="isShowDaySelector" :src="monthrightUrl" alt="" @click="changeMonth('+')">
                  </div>
                  <img class='change-time-img' :src="yearrightUrl" alt="" @click="changeYear('+')">
              </div>
              <hr class="top-hr">
              <!-- 当前月日期（包括上月和下月日期填充） -->
              <div v-show="isShowYearSelector" class="year-display-container">
                  <table>
                    <tr v-for="(row, rowIndex) in yearRows" :key="rowIndex">
                        <td
                          v-for="(year, index) in row"
                          :class="year.isCurrent && 'is-active'"
                          :key="index"
                          @click="selectYear(year)">
                          <div>{{ year.label }}</div>
                        </td>
                    </tr>
                  </table>
              </div>
              <div v-show="isShowMonthSelector" class="month-display-container">
                  <table>
                    <tr v-for="(row, rowIndex) in monthRows" :key="rowIndex">
                        <td
                          v-for="(month, index) in row"
                          :class="month.isCurrent && 'is-active'"
                          :key="index"
                          @click="selectMonth(month)">
                          <div>{{ month.label }}</div>
                        </td>
                    </tr>
                  </table>
              </div>
              <div v-show="isShowDaySelector" class="day-display-container">
                  <table>
                    <tr class="week-title">
                        <th  class="cell" v-for="(item, index) in weeks" :key="index">{{ item }}</th>
                    </tr>
                    <tr class="week-title" v-for="(item, rowIndex) in dateRows" :key="rowIndex">
                        <td
                        :class="['day-cell', currentDay(rowIndex, index)[1] ? 'day-cell-available custom-color' : 'disabled',  currentDayTimestamp(rowIndex, index) === selectedValue ? 'selected-day-cell custom-color' : '']"
                        v-for="(item, index) in weeks"
                        :key="index"
                        @click="select(rowIndex, index)">
                            <div>{{ currentDay(rowIndex, index)[0] }}</div>
                            <!-- <div>{{ currentDayTimestamp(rowIndex, index) == selectedValue }}</div> -->
                        </td>
                    </tr>
                  </table>
              </div>
              <hr class="confirm-top-hr">
              <!-- 确认选定的日期 -->
              <div class="confirm">
                  <button class="main-background-style custom-bg-color" @click="confirm">{{ $t('onboarding.nestle.confirm') }}</button>
              </div>
          </div>
        </div>
        <div v-if="internalErrorMessage" class="col-xs-12 col-sm-offset-5 col-md-offset-5 col-lg-offset-4 col-sm-7 col-md-7 col-lg-8 error-text">{{ this.internalErrorMessage }}</div>
    </div>
</template>
<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import moment from 'moment'
import { onboardingMixin } from './mixin.js'

// @label: the field title.
// @isEditable: whether this field can be edited.
// @notice: the notice message displayed on the bottom of the field.
// @placeholder: when value is empty, the placeholder text displayed on the field.
// @options: all options that can be selected.
// @isRequired: whether this field can be empty.

export default {
  directives: {
    Clickoutside
  },
  props: ['label', 'isEditable', 'notice', 'value', 'placeholder', 'isRequired'],
  mixins: [onboardingMixin],
  data () {
    return {
      minYear: 1900,
      isDisabled: this.isEditable === 'false',
      dateUrl: require('@/assets/image/onboarding/common/date.png'),
      yearleftUrl: require('@/assets/image/onboarding/common/arrow-dleft.png'),
      yearrightUrl: require('@/assets/image/onboarding/common/arrow-dright.png'),
      monthleftUrl: require('@/assets/image/onboarding/common/arrow-left.png'),
      monthrightUrl: require('@/assets/image/onboarding/common/arrow-right.png'),
      weeks: moment.weekdaysMin(),
      dateRows: [0, 1, 2, 3, 4, 5],
      displayText: '',
      showItem: false,
      internalValue: '',
      selectedValue: '',
      currentYear: (new Date()).getFullYear(),
      currentMonth: (new Date()).getMonth() + 1,
      currentDisplayDays: [],
      internalErrorMessage: '',
      inputValue: null,
      monthsText: moment.monthsShort(),
      isShowDaySelector: true,
      isShowMonthSelector: false,
      isShowYearSelector: false,
      monthRows: [],
      yearRows: []
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
    currentYearText () {
      if (this.isShowYearSelector) {
        const minYearText = this.$t('onboarding.nestle.year', { year: this.currentYear })
        const maxYearText = this.$t('onboarding.nestle.year', { year: this.currentYear + 9 })
        return minYearText + ' - ' + maxYearText
      } else {
        return this.$t('onboarding.nestle.year', { year: this.currentYear })
      }
    },
    currentMonthText () {
      return this.monthsText[this.currentMonth - 1]
    }
  },
  beforeCreate () {
    const current = moment.locale()
    const i18nLocale = this.$i18n.locale
    let locale = 'en'
    if (i18nLocale === 'zh') {
      locale = 'zh-cn'
    } else if (i18nLocale === 'tw') {
      locale = 'zh-tw'
    } else if (i18nLocale === 'hk') {
      locale = 'zh-hk'
    }
    if (current !== locale) {
      moment.locale(locale)
    }
    this.$eventBus.$on('momentLocaleChange', val => {
      this.monthsText = moment.monthsShort()
      this.weeks = moment.weekdaysMin()
    })
  },
  beforeMount () {
    this.match(this.value)
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('change', val)
    },
    showItem (val) {
      this.inputValue = this.displayText
      if (val) {
        this.openDaySelector()
      } else {
        const input = this.$refs.input
        if (input.value !== this.inputValue) {
          const momentDate = moment(input.value, 'MM/DD/YYYY', true)
          if (momentDate.isValid()) {
            this.internalValue = momentDate.format('MM/DD/YYYY')
            this.displayText = momentDate.format('MM/DD/YYYY')
            this.inputValue = this.displayText
          }
        }
      }
    },
    '$i18n.locale' (val) {
      this.validate()
    }
  },
  methods: {
    closePickerItems () {
      this.showItem = false
    },
    validate () {
      if (this.fieldIsRequired(this.isRequired) && !this.internalValue) {
        this.internalErrorMessage = this.isRequiredMessage
        return false
      }
      this.internalErrorMessage = ''
      return true
    },
    match (value) {
      let date = new Date()
      if (value) {
        date = new Date(Number(value))
        date = value.split('/')
        this.currentYear = Number(date[2])
        this.currentMonth = Number(date[0])
      } else {
        this.currentYear = date.getFullYear()
        this.currentMonth = date.getMonth() + 1
      }
      this.getDisplayDayArray(this.currentYear, this.currentMonth)
      if (value) {
        this.selectedValue = value
        this.internalValue = value
        this.displayText = value
        this.inputValue = this.displayText
      }
    },
    currentDay (rowIndex, index) {
      return this.currentDisplayDays[7 * rowIndex + index]
    },
    currentDayTimestamp (rowIndex, index) {
      if (!this.currentDay(rowIndex, index)[1]) {
        // 即使数字相同但不是当月日期，直接返回0
        return 0
      }
      let dayMonthNumber = this.currentDay(rowIndex, index)[0]
      if (dayMonthNumber < 10) {
        dayMonthNumber = '0'.concat(dayMonthNumber)
      }
      let month = this.currentMonth
      if (month < 10) {
        month = '0'.concat(month)
      }
      return `${month}/${dayMonthNumber}/${this.currentYear}`
    },
    toggle (event) {
      if (this.isDisabled) {
        return
      }
      if (this.showItem && event && event.target.dataset.hasOwnProperty('spInput')) {
        return
      }
      this.showItem = !this.showItem
    },
    getMonthFirstDay (year, month) {
      const firstDay = `${year}/${month}/01 00:00:00`
      return new Date(firstDay)
    },
    getMonthLastDay (year, month) {
      if (month === 12) {
        year += 1
        month = 0
      }
      const nextMonthFirstDay = this.getMonthFirstDay(year, month + 1)
      return new Date(nextMonthFirstDay.getTime() - 24 * 60 * 60 * 1000)
    },
    getDisplayDayArray (year, month) {
      const allDays = []
      let lastMonthMonth = month
      let lastMonthYear = year
      if (month === 1) {
        if (year <= this.minYear) {
          return
        }
        lastMonthMonth = 13
        lastMonthYear -= 1
      }
      const lastMonthLastDay = this.getMonthLastDay(lastMonthYear, lastMonthMonth - 1) // 上个月最后一天
      const lastMonthLastDayWeekNumber = lastMonthLastDay.getDay()
      const lastMonthLastDayMonthNumber = lastMonthLastDay.getDate()
      // 上个月日期
      for (let index = 0; index < lastMonthLastDayWeekNumber + 1; index++) {
        const number = lastMonthLastDayMonthNumber - lastMonthLastDayWeekNumber + index
        allDays.push([number, false])
      }
      // 这个月日期
      const currentMonthLastDayMonthNumber = this.getMonthLastDay(year, month).getDate()
      for (let index = 0; index < currentMonthLastDayMonthNumber; index++) {
        const number = index + 1
        allDays.push([number, true])
      }
      // 下个月日期
      for (let index = 0; index < (42 - currentMonthLastDayMonthNumber - lastMonthLastDayWeekNumber - 1); index++) {
        const number = index + 1
        allDays.push([number, false])
      }
      this.currentDisplayDays = allDays
    },
    changeMonth (type) {
      if (type === '-') {
        if (this.currentMonth === 1 && this.currentYear > this.minYear) {
          this.currentMonth = 12
          this.currentYear -= 1
        } else {
          this.currentMonth -= 1
        }
      } else {
        if (this.currentMonth === 12) {
          this.currentMonth = 1
          this.currentYear += 1
        } else {
          this.currentMonth += 1
        }
      }
      this.getDisplayDayArray(this.currentYear, this.currentMonth)
    },
    changeYear (type) {
      if (this.isShowYearSelector) {
        if (type === '-') {
          let min = this.currentYear - 10
          if (min <= this.minYear) {
            min = this.minYear
          }
          this.currentYear = min
        } else {
          this.currentYear += 10
        }
        this.openYearSelector()
      } else {
        if (type === '-') {
          if (this.currentYear > this.minYear) {
            this.currentYear -= 1
          }
        } else {
          this.currentYear += 1
        }
      }
      this.getDisplayDayArray(this.currentYear, this.currentMonth)
    },
    select (rowIndex, index) {
      const selectDayInfo = this.currentDay(rowIndex, index)
      if (!selectDayInfo[1]) {
        return
      }
      let dayMonthNumber = selectDayInfo[0]
      if (dayMonthNumber < 10) {
        dayMonthNumber = '0'.concat(dayMonthNumber)
      }
      let month = this.currentMonth
      if (month < 10) {
        month = '0'.concat(month)
      }
      this.selectedValue = `${month}/${dayMonthNumber}/${this.currentYear}`
    },
    confirm () {
      if (this.selectedValue) {
        this.internalValue = this.selectedValue
        this.displayText = this.selectedValue
        this.$refs.input.value = this.displayText
        this.internalErrorMessage = ''
      }
      this.toggle()
    },
    onPressEnter (event) {
      const input = event.target
      const momentDate = moment(input.value, 'MM/DD/YYYY', true)
      if (momentDate.isValid()) {
        this.currentYear = momentDate.year()
        this.currentMonth = momentDate.month() + 1
        let dayMonthNumber = momentDate.date()
        if (dayMonthNumber < 10) {
          dayMonthNumber = '0'.concat(dayMonthNumber)
        }
        let month = this.currentMonth
        if (month < 10) {
          month = '0'.concat(month)
        }
        this.selectedValue = `${month}/${dayMonthNumber}/${this.currentYear}`
        this.confirm()
      }
    },
    openYearSelector () {
      const min = this.currentYear
      const max = min + 10
      let rowIndex = 0
      for (let i = min; i < max; rowIndex++) {
        const row = []
        for (let j = 0; j < 4 && i < max; j++, i++) {
          row.push({
            value: i,
            label: i
          })
        }
        this.yearRows[rowIndex] = row
      }
      this.isShowMonthSelector = false
      this.isShowDaySelector = false
      this.isShowYearSelector = true
    },
    selectYear (year) {
      this.currentYear = year.value
      this.openMonthSelector()
    },
    openMonthSelector () {
      // this.currentMonth
      let month = null
      if (moment.locale() === 'en') {
        month = this.monthsText
      } else {
        month = moment.months()
      }
      let rowIndex = 0
      for (let i = 0; i < month.length; rowIndex++) {
        const row = []
        for (let j = 0; j < 4 && i < month.length; j++, i++) {
          row.push({
            value: i + 1,
            label: month[i]
          })
        }
        this.monthRows[rowIndex] = row
      }
      this.isShowDaySelector = false
      this.isShowYearSelector = false
      this.isShowMonthSelector = true
    },
    selectMonth (month) {
      this.currentMonth = month.value
      this.openDaySelector()
    },
    openDaySelector () {
      this.getDisplayDayArray(this.currentYear, this.currentMonth)
      this.isShowMonthSelector = false
      this.isShowYearSelector = false
      this.isShowDaySelector = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';

.onboarding-datetimepicker {
    margin-bottom: 1.2rem;
    .datetimepicker-container {
        padding: 0;
        display: inline-flex;
        flex-direction: column;
        .datetimepicker-selected {
            padding: 0 0.6rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
                height: 1.5rem;
                width: 1.6rem;
            }
            input {
              width: 100%;
              font-size: medium;
            }
        }
        .datetimepicker-items {
            border-top: solid 1px gray;
            background-color: white;
            padding: 0 0.6rem;
            z-index: 101;
            .year-month-display {
                margin-top: 20px;
                height: 2.5rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                div {
                    display: inline-flex;
                    font-size: small;
                }
                img {
                    user-select: none;
                    cursor: pointer;
                    height: 1.5rem;
                    width: 1.6rem;
                }
                .internal-div {
                    width: 70%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: space-between;
                    font-weight: bolder;
                }
                .center-display {
                    width: 100%;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    span {
                        font-size: medium;
                        padding: 0 5px;
                        cursor: pointer;
                        &:hover {
                        color: $common-color;
                        }
                    }
                }
            }
            .day-display-container {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                table {
                    width: 100%;
                }
                .week-title {
                    width: 100%;
                    margin-bottom: 2rem;
                    display: inline-flex;
                    justify-content: space-around;
                    align-items: center;
                    .cell {
                        font-size: small;
                        user-select: none;
                        width: 15px;
                        height: 15px;
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .disabled {
                        color: gray;
                    }
                    .day-cell {
                        @extend .cell;
                    }
                    .day-cell-available {
                        @extend .day-cell;
                        cursor: pointer;
                    }
                    .day-cell-available:hover {
                        color: $common-color;
                    }
                    .selected-day-cell {
                        color: $common-color;
                    }
                }
            }
            .year-display-container {
              table {
                width: 100%;
                td {
                  padding: 20px 3px;
                  cursor: pointer;
                  &:hover, &.is-active {
                    color: $common-color;
                  }
                  div {
                    font-size: medium;
                    text-align: center;
                  }
                }
              }
            }
            .month-display-container {
              table {
                width: 100%;
                td {
                  padding: 20px 3px;
                  cursor: pointer;
                  &:hover, &.is-active {
                    color: $common-color;
                  }
                  div {
                    font-size: medium;
                    text-align: center;
                  }
                }
              }
            }
            .confirm-top-hr {
                margin-top: 0;
                margin-bottom: 10px;
            }
            .confirm {
                margin-bottom: 10px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                button {
                    font-size: small;
                    height: 40px;
                    padding: 10px;
                    color: white;
                    border: none;
                }
            }
        }
    }
}

/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
    .year-month-display {
        height: 20px !important;
    }
    .top-hr {
        margin-top: 10px !important;
        margin-bottom: 10px !important;
    }
    .date-img {
        width: 20px !important;
        height: 20px !important;
    }
    .change-time-img {
        width: 20px !important;
        height: 20px !important;
    }
    .week-title {
        margin-bottom: 20px !important;
        font-size: medium !important;
        .cell {
            font-size: medium !important;
        }
        .day-cell {
            font-size: medium !important;
            div {
                font-size: medium !important;
            }
        }
    }
}
</style>
